export const REDUCER_NAME = "player";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_PLAYER = `${REDUCER_NAME}/SET_PLAYER`;

export const ROUTES = {
  STATISTICS: "/statistics",
  HISTORY: "/history",
  HOME: "/",
};
